import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentLocale } from '../reducers';
import Loader from '../components/Loader';
import moment from 'moment';
import intl from 'react-intl-universal';
import IntlPolyfill from 'intl';
import * as log from 'loglevel';

// TODO: remove later after ie11 require polyfill is added
//require(`moment/locale/bn`);
//require(`intl/locale-data/jsonp/bn.js`);

global.Intl = IntlPolyfill;

class I18nLoader extends Component {
  state = { initDone: false };
  extraLocaleDataLoaded = {};

  componentDidMount() {
    this.loadLocales();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentLocale !== this.props.currentLocale) {
      document.cookie = `lang=${this.props.currentLocale}; path=/`;
      this.setState(
        {
          initDone: false
        },
        this.loadLocales
      );
    }
  }

  loadLocales() {
    const { currentLocale } = this.props;

    if (currentLocale !== 'en' && !this.extraLocaleDataLoaded[currentLocale]) {
      this.extraLocaleDataLoaded[currentLocale] = true;
    }
    moment.locale(currentLocale);

    fetch(`/locales/${currentLocale}.json`)
      .then(response => {
        return response.json();
      })
      .then(json => {
        return intl.init({
          currentLocale,
          locales: {
            [currentLocale]: json
          }
        });
      })
      .then(() => {
        this.setState({ initDone: true });
      })
      .catch(error => {
        log.error('Language file load failed', error);
      });
  }

  render() {
    if (this.state.initDone) return this.props.children;
    return <Loader loading={true} />;
  }
}

const mapStateToProps = state => ({
  currentLocale: getCurrentLocale(state)
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(I18nLoader);
